import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
} from '@chakra-ui/react';

function AdminCredentialModal({ isOpen, onClose, overlay }) {
  return (
    <Modal isCentered isOpen={isOpen} onClose={onClose}>
      <ModalOverlay
        bg='blackAlpha.300'
        backdropFilter='blur(10px) hue-rotate(30deg)'
      />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody>{overlay}</ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default AdminCredentialModal;
